import { render, staticRenderFns } from "./LowerShelf.vue?vue&type=template&id=fd29db6a&scoped=true"
import script from "./LowerShelf.vue?vue&type=script&lang=js"
export * from "./LowerShelf.vue?vue&type=script&lang=js"
import style0 from "./LowerShelf.vue?vue&type=style&index=0&id=fd29db6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd29db6a",
  null
  
)

export default component.exports